
const pkg:Object = require('../../../package.json');

export default {
	version:`ryanspice.com [Version ${pkg.version}]<br/>
	ready`,
	copy:`Copyright (C) ryanspice.com. All rights reserved.`,
	directory:`~ryanspice.com\\users\\guest>`,
	opening:'opening ',
	login:{

		img:`./assets/images/if_key_298808.svg`
		,forgot:`Forgot Login?`
	},

	links:{
		banner:{
			link:'https://ryanspice.com/dev/newman/KevinNewmanHomeBannerVanillaJS-POC.html'
		},
		'auth':{
			link:'https://login.ryanspice.com/?ctx=1066',
			title:'', description:''
		},
		'restore':{
			link:`javascript:document.getElementById('console-listItem').style.display='none'; document.getElementById('console').classList.remove('slide-out-blurred-top'),document.getElementById('console').classList.remove('slide-out-blurred-minimize')`,
			title:'', description:''
		},
		'close':{
			link:`javascript:document.getElementById('console').classList.remove('slide-out-maximize');document.getElementById('console').classList.toggle('slide-out-blurred-top');document.getElementById('console-listItem').style.display='block';`,
			title:'', description:''
		},
		'help':{
			link:'',
			title:'', description:''
		},
		'image':{
			link:'',
			title:'', description:''
		},
		'maximize':{
			link:`javascript:document.getElementById('console').classList.remove('slide-out-maximize');document.getElementById('console').classList.toggle('slide-out-blurred-top');document.getElementById('console-listItem').style.display='block';`,
			title:'', description:''
		},
		'minimize':{
			link:`javascript:document.getElementById('console').classList.remove('slide-out-maximize');document.getElementById('console').classList.toggle('slide-out-blurred-minimize')`,
			title:'', description:''
		},
		'theme':{
			link:'',
			title:'', description:''
		},
		'Async2018':{
			link:'https://github.com/ryanspice/async-2018',
			title:'', description:''
		},
		'snow':{
			link:'https://ryanspice.com/examples/particles/',
			title:'', description:''
		},
		'rain':{
			link:'https://ryanspice.com/examples/particles_rain/',
			title:'', description:''
		},
		'Async2018-VirtualScroll':{
			link:'https://ryanspice.com/demo/asyncx/virtual-scroll.html',
			title:'', description:''
		},
		'Moon':{
			link:'https://ryanspice.com/abandoned/moon',
			title:'', description:''
		},
		'Hackio':{
			link:'https://ryanspice.com/abandoned/hackio',
			title:'', description:''
		},
		'Home':{
			link:'',
			title:'', description:''
		},
		'Jay':{
			link:'https://ryanspice.com/legacy/jay/',
			title:'', description:''
		},
		'SpiceJS-2016':{
			link:'https://www.npmjs.com/package/ryanspice2016-spicejs',
			title:'', description:''
		},
		'SpiceJS':{
			link:'https://github.com/ryanspice/spice.js/',
			title:'', description:''
		},
		'SpiceDocs':{
			link:'',
			title:'', description:''
		},
		'WebpackBabelFlowBoilerplate':{
			link:'https://github.com/ryanspice/babel-flow-webpack4-boilerplate',
			title:'', description:''
		},
		'Bovxel':{
			link:'https://ryanspice.com/game?game=Bovxel',
			title:'', description:''
		},
		'Tetris':{
			link:'https://ryanspice.com/Tetris/',
			title:'', description:''
		},
		'Dodgeball':{
			link:'https://ryanspice.com/Dodgeball/Dodgeball.zip',
			title:'', description:''
		},
		'FlappyFish':{
			link:'https://ryanspice.com/game?game=FlappyFish',
			title:'', description:''
		},
		'Fabagohey':{
			link:'https://ryanspice.com/demo/',
			title:'', description:''
		},
		'KongQuest':{
			link:'https://ryanspice.com/game?game=KongQuest',
			title:'', description:''
		},
		'ReverenceLost':{
			link:'https://ryanspice.com/game?game=ReverenceLost',
			title:'', description:''
		},
		'SnowBoarding':{
			link:'https://ryanspice.com/game?game=SnowBoarding',
			title:'', description:''
		},
		'esdoc-babel-plugin':{
			link:'https://github.com/ryanspice/esdoc-babel-plugin',
			title:'', description:''
		},
		'babel-boilerplate':{
			link:'https://github.com/ryanspice/vuejs-webpack4',
			title:'', description:''
		},
		'ng4+lightnin':{
			link:'https://github.com/ryanspice/ng4-lightning-currency-compare',
			title:'', description:''
		},
		'vuejs-webpack4':{
			link:'https://github.com/ryanspice/babel-flow-webpack4-boilerplate',
			title:'', description:''
		},
		'animated-banner':{
			link:'',
			title:'', description:''
		}

	}

}
